import { useSyncExternalStore } from "react";
import {
  hasInstallPrompt,
  installMethod,
  isStandalone,
  promptInstall,
  subscribeInstallPrompt,
  wasInstalled,
} from "../utils/installApp";

/**
 * Como oferecer "instalar o app" da loja neste aparelho (ver
 * utils/installApp.js). `method` é "prompt", "ios", "in-app", "manual", ou
 * null quando a loja já está instalada.
 */
export default function useInstallApp() {
  const hasPrompt = useSyncExternalStore(
    subscribeInstallPrompt,
    hasInstallPrompt,
  );
  const installed = useSyncExternalStore(subscribeInstallPrompt, wasInstalled);

  const method = installed
    ? null
    : installMethod({
        userAgent: window.navigator.userAgent,
        maxTouchPoints: window.navigator.maxTouchPoints,
        hasPrompt,
        standalone: isStandalone(),
      });

  return { method, install: promptInstall };
}
